import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const faqData = [
  {
    id: 1,
    category: 'general',
    categoryName: 'Общие вопросы',
    question: 'Нужно ли регистрировать ИП или проходить верификацию?',
    answer: 'Нет. RealWork.pro — открытая платформа без обязательной верификации личности. Это позволяет держать комиссии минимальными: вы платите процент только с выполненной работы, без абонентских взносов и скрытых платежей.'
  },
  {
    id: 2,
    category: 'general',
    categoryName: 'Общие вопросы',
    question: 'Кто владелец платформы?',
    answer: 'Команда проекта предпочитает не раскрывать личные данные публично — как и многие крипто-проекты, работающие в анонимном формате. Мы компенсируем это прозрачными правилами: чёткая система Escrow, фиксированные сроки рассмотрения споров и открытая поддержка по email.'
  },
  {
    id: 3,
    category: 'general',
    categoryName: 'Общие вопросы',
    question: 'Как связаться с поддержкой?',
    answer: 'Email указан в футере сайта и в разделе поддержки (realwork.support@gmail.com). Telegram-бот для быстрой связи сейчас находится в разработке.'
  },
  {
    id: 4,
    category: 'finance',
    categoryName: 'Безопасность и Финансы',
    question: 'Как физически защищены замороженные средства?',
    answer: 'Все средства, замороженные в рамках сделки, хранятся на выделенном кошельке платформы и блокируются системой на время выполнения задания. Это внутренний механизм защиты сделок (не смарт-контракт), поэтому доверие к нему строится на репутации платформы, а не на юридических гарантиях третьей стороны — учитывайте это при работе с крупными суммами.'
  },
  {
    id: 5,
    category: 'tasks',
    categoryName: 'Заказы и Дедлайны',
    question: 'Что будет, если исполнитель не сдал работу вовремя?',
    answer: 'Если дедлайн истёк, а отчёт не отправлен, задание автоматически возвращается в общую ленту и становится доступно другим исполнителям. Заказчик ничего не теряет.'
  },
  {
    id: 6,
    category: 'finance',
    categoryName: 'Безопасность и Финансы',
    question: 'Как рассчитывается комиссия?',
    answer: 'Комиссия 7% берётся один раз с исполнителя при успешном закрытии сделки. Например, если заказчик выставил задание за 100 USDT, исполнитель получает 93 USDT, а 7 USDT идёт на поддержку сервера, разработку и продвижение платформы.'
  },
  {
    id: 7,
    category: 'finance',
    categoryName: 'Безопасность и Финансы',
    question: 'Как вывести заработанные USDT?',
    answer: 'Вывод доступен на любые кошельки в сетях TON, TRC-20, BNB, ERC-20, POL. Минимальная сумма вывода — 5 USDT. Комиссию сети оплачивает пользователь; размер комиссии указан на странице вывода перед подтверждением.'
  },
  {
    id: 8,
    category: 'disputes',
    categoryName: 'Споры и Арбитраж',
    question: 'Кто решает споры между заказчиком и исполнителем?',
    answer: 'Споры рассматривает модератор платформы на основе предоставленных доказательств (переписка, файлы, скриншоты).'
  },
  {
    id: 9,
    category: 'disputes',
    categoryName: 'Споры и Арбитраж',
    question: 'Сколько времени занимает рассмотрение спора?',
    answer: 'До 12 часов с момента открытия спора.'
  },
  {
    id: 10,
    category: 'disputes',
    categoryName: 'Споры и Арбитраж',
    question: 'Что происходит с деньгами во время спора?',
    answer: 'Средства остаются заблокированными до решения. Если спор решён в пользу заказчика, деньги возвращаются ему полностью — без удержания комиссии.'
  },
  {
    id: 11,
    category: 'finance',
    categoryName: 'Безопасность и Финансы',
    question: 'Нужна ли верификация (KYC) для вывода средств?',
    answer: 'На данный момент — нет. Это может измениться в будущем при масштабировании платформы.'
  },
  {
    id: 12,
    category: 'general',
    categoryName: 'Общие вопросы',
    question: 'Как защищён мой аккаунт?',
    answer: 'Двухфакторная аутентификация (2FA) находится в разработке и появится в ближайших обновлениях.'
  },
  {
    id: 13,
    category: 'tasks',
    categoryName: 'Заказы и Дедлайны',
    question: 'Кто размещает заказы — реальные компании или кто угодно?',
    answer: 'Заказы может размещать любой зарегистрированный пользователь. Каждое задание проходит модерацию перед публикацией.'
  },
  {
    id: 14,
    category: 'tasks',
    categoryName: 'Заказы и Дедлайны',
    question: 'Проверяются ли задания перед публикацией?',
    answer: 'Да, модерация занимает до 10 минут — это защищает платформу от мошеннических или незаконных заданий.'
  },
  {
    id: 15,
    category: 'finance',
    categoryName: 'Безопасность и Финансы',
    question: 'Что делать, если я перевел неточную сумму или деньги не зачислились?',
    answer: 'Если вы отправили сумму меньше/больше указанной или произошла задержка сети, автоматическая обработка платежа может не сработать. Не переживайте: ваши средства надежно поступают на кошелек платформы. Напишите в службу поддержки (realwork.support@gmail.com), указав хэш транзакции (TxID) и ваш логин — администратор проверит платеж и зачислит средства вручную.'
  }
];

function FAQ({ onClose }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [openId, setOpenId] = useState(null);
  const [activeCategory, setActiveCategory] = useState('all');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleAcc = (id) => {
    setOpenId(openId === id ? null : id);
  };

  const filteredFaq = faqData.filter(item => {
    const matchesSearch = item.question.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          item.answer.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCat = activeCategory === 'all' || item.category === activeCategory;
    return matchesSearch && matchesCat;
  });

  // Генерация JSON-LD микроразметки для поисковиков (Schema.org / FAQPage)
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  return (
    <div className="min-h-screen bg-[#090d16] text-white flex flex-col font-sans">
      <Helmet>
        <title>Часто задаваемые вопросы (FAQ) — RealWork.pro</title>
        <meta name="description" content="Ответы на популярные вопросы о работе фриланс-биржи RealWork.pro: комиссии 7%, безопасные сделки Escrow, выводы в USDT и отсутствие KYC." />
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      </Helmet>

      {/* ШАПКА */}
      <header className="sticky top-0 z-50 bg-[#0f172a]/90 backdrop-blur-md border-b border-slate-800 px-4 py-4 sm:px-8 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-tr from-indigo-500 to-purple-500 flex items-center justify-center font-bold text-white text-lg shadow-md shadow-indigo-500/20">
            R
          </div>
          <span className="font-bold text-xl tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-300">
            Realwork<span className="text-indigo-400">.pro</span>
          </span>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="flex items-center gap-2 px-3.5 py-1.5 rounded-xl bg-slate-800/80 hover:bg-slate-700 text-gray-300 hover:text-white text-xs font-bold transition border border-slate-700/60 cursor-pointer"
          >
            ✕ Назад на главную
          </button>
        )}
      </header>

      {/* КОНТЕНТ */}
      <main className="flex-1 max-w-4xl w-full mx-auto px-4 py-10 sm:py-14">
        {/* ЗАГОЛОВОК */}
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-xs font-bold uppercase tracking-wider mb-3">
            База знаний
          </span>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-3 text-white">
            Часто задаваемые вопросы
          </h1>
          <p className="text-gray-400 text-sm sm:text-base max-w-xl mx-auto">
            Всё, что нужно знать о правилах работы, комиссиях, выводе USDT и арбитраже на RealWork.pro
          </p>
        </div>

        {/* ПОИСК И ФИЛЬТРЫ */}
        <div className="space-y-4 mb-8">
          <div className="relative">
            <input
              type="text"
              placeholder="Поиск по вопросам и ответам..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full bg-[#111827] border border-slate-800 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 rounded-2xl py-3.5 pl-11 pr-4 text-white placeholder-gray-500 text-sm outline-none transition shadow-inner"
            />
            <svg className="w-5 h-5 text-gray-500 absolute left-4 top-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>

          <div className="flex flex-wrap gap-2 justify-center sm:justify-start">
            {[
              { id: 'all', label: 'Все вопросы' },
              { id: 'general', label: 'Общие' },
              { id: 'finance', label: 'Финансы и Выводы' },
              { id: 'tasks', label: 'Заказы' },
              { id: 'disputes', label: 'Споры' },
            ].map(cat => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`px-3.5 py-1.5 rounded-xl text-xs font-semibold transition cursor-pointer border ${
                  activeCategory === cat.id
                    ? 'bg-indigo-600 text-white border-indigo-500 shadow-md shadow-indigo-600/20'
                    : 'bg-[#111827] text-gray-400 border-slate-800 hover:text-white hover:border-slate-700'
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>

        {/* СПИСОК АККОРДЕОНОВ */}
        <div className="space-y-3">
          {filteredFaq.length > 0 ? (
            filteredFaq.map(item => {
              const isOpen = openId === item.id;
              return (
                <div
                  key={item.id}
                  className="bg-[#111827]/70 border border-slate-800/80 rounded-2xl overflow-hidden transition-all duration-200"
                >
                  <button
                    onClick={() => toggleAcc(item.id)}
                    className="w-full text-left p-4 sm:p-5 flex items-start justify-between gap-4 hover:bg-slate-800/30 transition cursor-pointer outline-none"
                  >
                    <span className="font-bold text-sm sm:text-base text-gray-200 pt-0.5 leading-snug">
                      {item.question}
                    </span>
                    <span className={`w-7 h-7 rounded-xl flex items-center justify-center bg-slate-800 text-indigo-400 font-bold shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180 bg-indigo-500/20' : ''}`}>
                      ↓
                    </span>
                  </button>

                  {isOpen && (
                    <div className="px-4 pb-5 sm:px-5 sm:pb-5 pt-0 text-gray-300 text-xs sm:text-sm leading-relaxed border-t border-slate-800/40 mt-1">
                      <div className="pt-3 text-slate-300">
                        {item.answer}
                      </div>
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            <div className="text-center py-12 bg-[#111827]/30 rounded-2xl border border-slate-800/50">
              <p className="text-gray-400 text-sm">Ничего не найдено по запросу «{searchTerm}»</p>
            </div>
          )}
        </div>

        {/* БЛОК ПОДДЕРЖКИ */}
        <div className="mt-12 p-6 sm:p-8 rounded-2xl bg-gradient-to-r from-indigo-900/20 via-purple-900/10 to-transparent border border-indigo-500/20 text-center">
          <h3 className="font-bold text-base sm:text-lg text-white mb-2">Остались вопросы?</h3>
          <p className="text-gray-400 text-xs sm:text-sm mb-4">
            Наша команда поддержки готова отвечать на любые обращения по электронной почте
          </p>
          <a
            href="mailto:realwork.support@gmail.com"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-500 text-white font-bold text-xs transition shadow-lg shadow-indigo-600/20"
          >
            ✉ Написать в поддержку: realwork.support@gmail.com
          </a>
        </div>
      </main>

      {/* ФУТЕР */}
      <footer className="border-t border-slate-800/60 py-6 text-center text-xs text-gray-500">
        © 2026 Realwork.pro. Все права защищены.
      </footer>
    </div>
  );
}

export default FAQ;